export const defaultHeaders: any = {
    header: [
        {
            name: 'descricao',
            text: 'Descrição',
            position: 1
        },
        {
            name: 'quantidadeTotal',
            text: 'Quantidade Total',
            position: 2,
            alignTo: 'center'
        },
        {
            name: 'totalValorRegistradora',
            text: 'Valor Total Registradora',
            position: 3
        },
        {
            name: 'totalTaxaRegistro',
            text: 'Valor Total Taxa Registro',
            position: 4
        }
    ]
}

export const keysFormatCurrency = [
    'valorRegistradora',
    'taxaRegistro',
    'totalValorRegistradora',
    'totalTaxaRegistro'
]
